import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { RecursoCampanhaFilter } from '../filter';
import { RecursoCampanhaSearch, RecursoCampanhaSearchTotal } from '../recurso-campanha-search';

@Injectable({
    providedIn: 'root'
})
export class RecursoCampanhaSearchHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/recursocampanha`;
    }


    /** Realizada a pesquisa os recursos de campanhas */
    search(filter: RecursoCampanhaFilter, orderBy: number, orderByDir: string, limit: number, offset: number): Observable<RecursoCampanhaSearch[]> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }
        // Order By
        params = params.append('orderBy', orderBy ? orderBy.toString() : null)
                    .append('orderByDir', orderByDir ? orderByDir : null);
        // Limit
        params = params.append('limit', limit ? limit.toString() : null);
        // Offset
        params = params.append('offset', offset ? offset.toString() : null);

        return this.customHttp.get<RecursoCampanhaSearch[]>(this.pathApi, {params});
    }

    /** Obtem os totais da pesquisa dos recursos de campanhas cadastrados */
    getTotais(filter: RecursoCampanhaFilter): Observable<RecursoCampanhaSearchTotal> {
        // Params
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<RecursoCampanhaSearchTotal>(`${this.pathApi}/0/total`, {params});
    }
}
